<notify-popup
  *ngIf="setDefaultCvNotify"
  (onChanged)="setDefaultCvNotifyConfirm($event)"
  [cancelLabel]="'FilesManager.Ignore' | translate"
  [okLabel]="'FilesManager.SetDefaultCv' | translate"
  [title]="'FilesManager.SetDefaultCv' | translate"
  [msg]="'FilesManager.SetDefaultCvConfirm' | translate"
  [checkboxStorageKey]="'noDefaultCvNotify'"
  [checkboxOnClose]="true">
</notify-popup>

<div class="files-manager-bg" *ngIf="isAttach" (click)="close()" [@opacityInOut] [@.disabled]="!isAttach"></div>
<div class="files-manager" [class.a-section]="!parseCv" [class.is-modal]="isAttach" [@scaleInOut] [@.disabled]="!isAttach">
  <i class="app-ico-mask app-ico-mask__x" *ngIf="isAttach" (click)="close()"></i>

  <ng-container *ngIf="!parseCv">
    <div class="a-section__title" *ngIf="!isAttach">
      <i class="app-ico-mask app-ico-mask__document"></i> {{ 'FilesManager.FilesStorage' | translate }} 
    </div>

    <div class="files-manager__default-cv" 
      *ngIf="!isAttach && isTalent && defaultCvFiles && defaultCvFiles.length">
      <a-select
        [label]="'FilesManager.SelectDefaultCv' | translate"
        [useLables]="true"
        [hasClear]="true"
        [enableSearch]="false"
        [items]="defaultCvFiles"
        [control]="defaultCv"
        [savingStatus]="savingDefaultCv"
        (onValueChanged)="checkDefaultCv($event)">
      </a-select>
    </div>

    <div class="files-manager__header" *ngIf="isAttach">
      <h1>{{ 'FilesManager.SendFile' | translate }}</h1>
    </div>

    <notify-popup 
      *ngIf="fileForDelete"
      (onChanged)="deleteFileResult($event)"
      [cancelLabel]="'Common.No' | translate"
      [okLabel]="'Common.Yes' | translate"
      [title]="'FilesManager.DeleteFile' | translate"
      [msg]="'FilesManager.DeleteFileConfirm' | translate">
    </notify-popup>

    <div class="files-manager__section">
      <div class="files-manager__storage">
        <span>{{ totalStorageSize | bytesConverter }}/30MB</span>
        <div class="files-manager__storage__bar" 
          [style.width]="((totalStorageSize * 100) / (1024 * 1024 * 30)).toFixed(2) + '%'">
        </div>
      </div>
      <div class="files-manager__items is-scroll" 
        *ngIf="userFiles && userFiles.length"
        [class.is-disabled]="fileLoadingProccess !== null || blockView">
        <div class="files-manager__item" *ngFor="let file of userFiles; let i = index">
          <div class="is-download">
            <input id="radio-{{ i }}"
              *ngIf="isAttach"
              (change)="onChange($event, file)"
              name="radio" 
              type="radio">
            <label *ngIf="isAttach" for="radio-{{ i }}" class="radio-label">
              <i class="app-ico-mask"
                [ngClass]="file.type === 'image/png' || file.type === 'image/jpeg'
                  ? 'app-ico-mask__image' : 'app-ico-mask__document'">
              </i>
              <div class="is-name">{{ file.name }}</div>
            </label>
            <i class="app-ico-mask" *ngIf="!isAttach"
              [ngClass]="file.type === 'image/png' || file.type === 'image/jpeg'
                ? 'app-ico-mask__image' : 'app-ico-mask__document'">
            </i>
            <div *ngIf="!isAttach" class="is-name">{{ file.name }}</div>
          </div>
          <div>
            <div class="is-date">{{ file.created | date: 'dd.MM.YY' }}</div>
            <div class="is-size">{{ file.size | bytesConverter }}</div>
            <i class="app-ico-mask app-ico-mask__download" (click)="!downloadInProgress && download(file)"></i>
          </div>
          <i class="app-ico-mask app-ico-mask__x" (click)="deleteFile(file)"></i>
        </div>
      </div>

      <div class="files-manager__no-files"
        *ngIf="!userFiles || (userFiles && !userFiles.length)">
        <div class="files-manager__no-files__inner">
          {{ 'FilesManager.StorageInfo' | translate }}
        </div>
      </div>

      <div class="files-manager__btns">
        <div class="files-manager__error" [class.is-modal]="isAttach" *ngIf="showError" @opacityInOut>
          {{ showError }}
        </div>
        <div class="is-btn is-btn__outfill" *ngIf="isAttach" (click)="close()">{{ 'Common.Cancel' | translate }}</div>
        <label for="fileUpload" class="is-btn is-btn__outfill" 
          [class.is-loading]="fileLoadingProccess !== null"
          [class.is-disabled]="showError || blockView"
          (click)="setupFocusListener()">
          <input id="fileUpload" name="fileUpload" type="file" #fileUpload
            (change)="onFileChange($event)"
            [accept]="possibleExt">
          <div class="files-manager__btns__loader" *ngIf="fileLoadingProccess" @opacityInOut>
            <div class="round-loader"></div>
          </div>
          <span *ngIf="fileLoadingProccess">{{ fileLoadingProccess }}% {{ 'FilesManager.Uploading' | translate }}</span>
          <span *ngIf="fileLoadingProccess === 0">{{ 'FilesManager.Processing' | translate }}</span>
          <span *ngIf="fileLoadingProccess === null">{{ 'FilesManager.Upload' | translate }}</span>
        </label>
        <div class="is-btn" [class.is-disabled]="!selectedFile" *ngIf="isAttach" (click)="close(true)">{{ 'FilesManager.Send' | translate }}</div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="parseCv">
    <div class="files-manager__parse">
      <!-- <div class="files-manager__error" [class.is-modal]="isAttach" *ngIf="showError" @opacityInOut>
        {{ showError }}
      </div> -->
      <label for="fileUpload" class="is-btn is-btn__outfill" 
        [class.is-loading]="fileLoadingProccess !== null"
        [class.is-disabled]="showError || blockView"
        (click)="setupFocusListener()">
        <input id="fileUpload" name="fileUpload" type="file" #fileUpload
          (change)="onFileChange($event, true)"
          [accept]="possibleExt">
        <div class="files-manager__btns__loader" *ngIf="fileLoadingProccess" @opacityInOut>
          <div class="round-loader"></div>
        </div>
        <span *ngIf="fileLoadingProccess">{{ fileLoadingProccess }}% {{ 'FilesManager.Uploading' | translate }}</span>
        <span *ngIf="fileLoadingProccess === 0">{{ 'FilesManager.Processing' | translate }}</span>
        <span *ngIf="fileLoadingProccess === null">{{ 'FilesManager.ParseCv' | translate }}</span>
      </label>
    </div>
  </ng-container>


</div>